import { Injectable } from "@angular/core";
import { invalidConditions } from "../classes/invalid-url-conditions";

/**
 * A helper service to validate urls for SEO
 */
@Injectable()
export class UrlSanitizerService {
  constructor() {}

  /**
   * Goes through each of the invalid conditions for a url and applies their handler.
   * @param url takes a url string as input
   * @returns a sanitized url
   */
  sanitizeUrl(url: string): string {
    let sanitizableUrl = url;
    for (const condition in invalidConditions) {
      if (sanitizableUrl.match(invalidConditions[condition].matcher)) {
        sanitizableUrl = invalidConditions[condition].handler(sanitizableUrl);
      }
    }
    return sanitizableUrl;
  }
}


